"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExhaustUnpredictableError = void 0;
const effect_1 = require("effect");
/**
 * Error indicating that the date upon which the consumable in question will reach its `rangeExhaust` can not be predicted
 */
class ExhaustUnpredictableError extends effect_1.Data.TaggedError('ExhaustUnpredictableError') {
    get message() {
        return ('The exhaust date of the consumable can not be predicted, ' +
            `because ${ExhaustUnpredictableError.getReasonMessage(this.reason)}.`);
    }
    static getReasonMessage(reason) {
        return effect_1.Match.value(reason).pipe(effect_1.Match.when('Unused', () => 'the consumable has not been used yet'), effect_1.Match.exhaustive);
    }
}
exports.ExhaustUnpredictableError = ExhaustUnpredictableError;
//# sourceMappingURL=common.js.map